import React, { forwardRef, useEffect, useState } from "react";
import { getFormValues, reduxForm } from "redux-form";
import { Input } from "../../../UI/InputElement/InputElement";
import { connect, useSelector } from "react-redux";
import { availabilityFormValidator as validate } from '../../../../../utility/validator/validator';
import { availability_initial_data, selectDay } from "../../../../../utility/constants/constants";
import ErrorAlert from "../../../../../utility/errorHandler/errorAlert";
import { DateTimeField } from "../../../UI/DateTimeField/DateTimeField";
import { convertTo24HourFormat } from "../../../../../utility/utility";

let AddAvailability = (props) => {

    const { handleSubmit, change } = props;
    const Availability = props.formStates.data?.availability
    const isCreateAvailabilityClicked = useSelector((state) => state.TimeTrackerModReducer.isCreateAvailabilityClicked)
    
    const [availableDays, setAvailableDays] = useState(availability_initial_data)
    const [timeData, setTimeData] = useState({})
    useEffect(() => {
            setTimeout(() => {
                availableDays.map((item, index) => {
                    let ele = document.getElementById(`triggerPoint-${item.day}-${ item.slot.length - 1}`)
                    if (ele) {
                        ele.click();
                    }
                })
            }, 500);
        }, [])

        useEffect(() => {
            const initialValue = JSON.stringify(availability_initial_data)
            setAvailableDays(JSON.parse(initialValue))
        },[isCreateAvailabilityClicked])

    const fromDate = (date) => {
        if (!date) {
            return 'From'
        } else {
            const formattedDate = new Date(date)
            const month = formattedDate.toLocaleString('en-US', { month: 'long' });
            const year = formattedDate.getFullYear();
            return `${month} ${year}`;
        }
    };

    const FromCustomInput = forwardRef(({ value, onClick }, ref) => (

        <div style={{ marginLeft: "-20px", cursor: 'pointer' }} className="font-weight-bold h6" onClick={onClick} ref={ref}>
            {fromDate(value)} <i style={{ fontSize: "17px" }} className="fa">&#xf107;</i>
        </div>
    ));

    const toDate = (date) => {
        if (!date) {
            return 'To'
        } else {
            const formattedDate = new Date(date)
            const month = formattedDate.toLocaleString('en-US', { month: 'long' });
            const year = formattedDate.getFullYear();
            return `${month} ${year}`;
        }
    };

    const ToCustomInput = forwardRef(({ value, onClick }, ref) => (

        <div style={{ marginLeft: "-20px", cursor: 'pointer' }} className="font-weight-bold h6" onClick={onClick} ref={ref}>
            {toDate(value)} <i style={{ fontSize: "17px" }} className="fa">&#xf107;</i>
        </div>
    ));

    const handleCreateSlots = (index) => {
        
        let slots = [...availableDays];
        slots[index].slot.push({ start: '', end: '' });
        setAvailableDays(slots);
        setTimeout(() => {
            let ele = document.getElementById(`triggerPoint-${slots[index].day}-${ slots[index].slot.length - 1}`)
            if (ele) {
                ele.click();
            }
        }, 100);
        let items = props.formStates.data.availability[index].slot;
    }

    const handleRemoveSlots = (index, subindex) => {
        
        let slots = [...availableDays];
        slots[index].slot.splice(subindex, 1);
        setAvailableDays(slots);
            let items = Availability[index].slot;
            items.splice(subindex, 1);
            change(`data[availability][${index}][slot]`, items);
        
    }

    const handleDayChange = (index) => {
        let slots = [...availableDays];
        slots[index].isAvailable = !slots[index].isAvailable
        if( !slots[index].isAvailable){
            slots[index].slot = [{ start: '', end: '' }]
            change(`data[availability][${index}][slot]`, [{ triggerPoint: 'true', start: '', end: '' }]);
        }
        setAvailableDays(slots);
        
    }

    const checkTimeField = (index) => {
        if(Availability && Availability[index]){
            const slot = Availability[index].slot
            const start =  Availability[index].slot[slot.length - 1]?.start
            const end =   Availability[index].slot[slot.length - 1]?.end
            if(start && end){
             return true
            }else{
             return false
            }
        }
    }

    const timeOnChangeHandler = (value, index, subindex, fieldName) => {
        let startTime;
        let endTime;

        const checkStartTime = Availability[index].slot[subindex].start
        const checkEndTime = Availability[index].slot[subindex].end

        if(fieldName == 'start'){
            startTime = value
            endTime = checkEndTime ? checkEndTime : null//new Date('9999-12-31T23:59:59')
        }else{
            endTime = value
            startTime = checkStartTime
        }

        setTimeData({startTime, endTime, index, subindex})
    }

    const addAvailabilityHandler = (event) => {

        event.preventDefault()

        // Common function to check for time conflicts
    const checkForTimeConflict = (selectedStartTime, selectedEndTime, currentIndex, subindex) => {
        
         let error = '';
         let validate = false;
        // Validate input: Start time must be before End time
        if (!selectedStartTime || !selectedEndTime ) {
            return false;
        }

        if (selectedStartTime === selectedEndTime) {
            error = 'Start time must not be equal to end time.'
            validate =  true
        }

        if (convertTo24HourFormat(selectedEndTime) < convertTo24HourFormat(selectedStartTime)){
            error = 'End time must be greater than start time.'
            validate =  true
        }
        
    
        let existingSlots = [...Availability[currentIndex].slot];
    
        // Remove the current slot from checking to avoid self-comparison
        
        existingSlots.splice(subindex, 1);
    
        const hasConflict = existingSlots && existingSlots.some(slot => {
            const existingStartTime = slot.start;
            const existingEndTime = slot.end;
    
            // Skip incomplete entries
            if (!existingStartTime || !existingEndTime) return false

            

            if(existingStartTime === existingEndTime){
                error = 'Start time must not be equal to end time.'
                validate =  true
            }
            
            if(convertTo24HourFormat(existingEndTime) < convertTo24HourFormat(existingStartTime)){
                error = 'End time must be greater than start time.'
                validate =  true
            }

    
            // Check for overlap (without allowing consecutive times)
            if (
                convertTo24HourFormat(selectedStartTime) >= convertTo24HourFormat(existingStartTime) &&
                convertTo24HourFormat(selectedStartTime) < convertTo24HourFormat(existingEndTime)
            ) {
                error = 'Selected start time is overlapping with existing time'
                validate =  true
            }
            else if(
                convertTo24HourFormat(selectedEndTime) > convertTo24HourFormat(existingStartTime) &&
                convertTo24HourFormat(selectedEndTime) <= convertTo24HourFormat(existingEndTime)
            ){
                error = 'Selected end time is overlapping with existing time'
                validate =  true
            }
        });
    
        if (validate) {
            ErrorAlert(error);
        }
    
        return validate;
    };

        const hasConflict = checkForTimeConflict(timeData.startTime, timeData.endTime, timeData.index, timeData.subindex)

        if(!hasConflict){
            handleSubmit(event)
        }
        

    }
    
    

    return (
        <main className="app-content wraper_content user_newQuote add_account_modal add_New_Accont newuser">
            <div className="inspection_content_sec appcontent_Inner">
                <div className="container-fluids">
                    <div className="ticket_form"> <h2 className="md_title"> Add Availability </h2> </div>
                    <form onSubmit={(values) => addAvailabilityHandler(values)} className="form_content">
                        <div className="quote_form availability_form">
                            <div className="addQuote_form scroll_acc_com">

                                <div className="">
                                    <div className="row align-items-center" >

                                        <div className="col-md-2"> <label className="form_title fw-bold"> Date Cycle </label> </div>

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="form_title fw-bold"> Start Date <sup className="cst_sup_txt text_danger">*</sup></label>
                                                <div className="input-group cst_input_group col-lg-14 pl-0">
                                                    <Input
                                                        datePickerType={"react-datepicker"}
                                                        type="date"
                                                        minDate={new Date()}
                                                        dateFormat={"MM-dd-yyyy"}
                                                        name={`data[start_date]`}
                                                        className="form-control input-modifier"
                                                    // component={<ToCustomInput />}
                                                    //showMonthYearPicker={true}
                                                    />
                                                    <div className="input-group-append cursor-pointer" style={{ float: "right", position: "absolute", right: 0, height: "36px", top: 0 }}>
                                                        <span class="input-group-text" id="basic-addon2"> <i class="fa fa-calendar"></i> </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="form_title fw-bold"> End Date <sup className="cst_sup_txt text_danger">*</sup></label>
                                                <div className="input-group cst_input_group col-lg-14 pl-0">
                                                    <Input
                                                        datePickerType={"react-datepicker"}
                                                        type="date"
                                                        minDate={props.formStates?.data?.start_date}
                                                        dateFormat={"MM-dd-yyyy"}
                                                        name={`data[end_date]`}
                                                        className="form-control input-modifier"
                                                    // component={<ToCustomInput />}
                                                    //showMonthYearPicker={true}
                                                    />
                                                    <div className="input-group-append cursor-pointer" style={{ float: "right", position: "absolute", right: 0, height: "36px", top: 0 }}>
                                                        <span class="input-group-text" id="basic-addon2"> <i class="fa fa-calendar"></i> </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                
                                {availableDays.map((item, index) => (
                                    <div key={index} className="cst_tab_content">
                                        <div className="row align-items-center">

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <div className="checkbox_block radius_checkbox">
                                                        <div className="custom-control custom-checkbox">
                                                            <Input
                                                                type="checkbox"
                                                                name={`data[availability][${index}][day]`}
                                                                className="custom-control-input"
                                                                id={`customCheck${index}`}
                                                                handleChange={() => handleDayChange(index)}
                                                            />
                                                            <label className="custom-control-label form_title" for={`customCheck${index}`}> {item.day} </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            { item.slot.map((value, subindex) => (
                                                  <>
                                                    {subindex != 0 ? <div className="col-md-2"></div> : null}
                                                    <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label  className="form_title"> Start Time </label>
                                                        <DateTimeField disabled={!item.isAvailable} onChange={(value) => timeOnChangeHandler(value, index, subindex, 'start')} name={`data[availability][${index}][slot][${subindex}][start]`} timeConstraints={{ minutes: { step: 1 } }} datePickerType='react-datetime' pickerType="timePicker" dataFormat="hh:mm A" className="form-control Input-modifier" />
                                                    </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label className="form_title"> End Time </label>
                                                        <DateTimeField disabled={!item.isAvailable} onChange={(value) => timeOnChangeHandler(value, index, subindex, 'end')} name={`data[availability][${index}][slot][${subindex}][end]`} timeConstraints={{ minutes: { step: 1 } }} datePickerType='react-datetime' pickerType="timePicker" dataFormat="hh:mm A"  className="form-control input-modifier" />
                                                    </div>
                                                    </div>

                                                    <div className="col-md-2 mt-3">
                                                        {
                                                        subindex != 0 ? <button type="button" class="btn btn-dark" onClick={() => handleRemoveSlots(index, subindex)}><i className="far fa-trash-alt"></i></button> : item.isAvailable === true && checkTimeField(index) ? <img src='../images/icons/more.png' alt='addIcon' style={{cursor : 'pointer'}} height={38} width={38} onClick={() => handleCreateSlots(index)} /> : <img src='../images/icons/grey-more.png' alt='addIcon'  height={38} width={38}  />
                                                        }
                                                    </div>
                                                     <div style={{ display: 'none' }}>
                                                        <Input
                                                            type="radio"
                                                            forLable={`triggerPoint-${subindex}`}
                                                            value={"true"}
                                                            className="custom-control-input"
                                                            id={`triggerPoint-${item.day}-${subindex}`}
                                                            name={`data[availability][${index}][slot][${subindex}][triggerPoint]`}
                                                        />
                                                    </div>
                                                    </>
                                
                                            ))
                                            
                                            }
                                        </div>
                                    </div>
                                ))}

                                <div className="modal-footer">
                                    <button data-test="cancel_button" type="button" className="btn btn-outline-secondary cst_btn w-25" onClick={() => props.onCancelClicked()}> Cancel </button>
                                    <button data-test="submit_button" type="submit" disabled={props.isLoading} className={props.isLoading ? "btn cst_btn btn_danger mr-2 btn-wait w-25" : "btn cst_btn btn_danger mr-2 w-25"}> {props.isLoading ? "" : "Submit"} </button>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </main>
    );
}

const mapStateToProps = (state) => {

    return {  formStates: getFormValues('addAvailabilityForm')(state) || {} };

};

AddAvailability = reduxForm({
    form: "addAvailabilityForm",
    validate,
    enableReinitialize: true,
})(AddAvailability);

AddAvailability = connect(mapStateToProps)(AddAvailability);

export default AddAvailability;